<template>
    <a
        :href="href"
        :target="target"
    >
        <slot></slot>
    </a>
</template>

<script>
export default {
    props: ["field"],

    computed: {
        href() {
            return this.field ? this.field.url : "#";
        },

        target() {
            return this.field ? this.field.target : "#";
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Anchor.vue